import { render, staticRenderFns } from "./caseClip_course.vue?vue&type=template&id=02a97ee0&scoped=true"
import script from "./caseClip_course.vue?vue&type=script&lang=js"
export * from "./caseClip_course.vue?vue&type=script&lang=js"
import style0 from "./caseClip_course.vue?vue&type=style&index=0&id=02a97ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a97ee0",
  null
  
)

export default component.exports